let utils = require('../../actions/utils');
let redirect = require('../../actions/redirect');

module.exports = {
    onRedirect: [
        utils.setArgFromState('url', ['payment', 'redirectLink']),
        utils.setArg('delay', 5000),
        redirect.redirectFromArgs
    ]
};



// WEBPACK FOOTER //
// ./signals/payment/index.js